import styled from 'styled-components';

export const FormWrap = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;

  .MuiFormControl-root {
    margin-bottom: 20px;
  }
`;

export const FormColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 48%;

  &.full-width {
    width: 100%;
  }

  @media (max-width: 720px) {
    width: 100%;
  }
`;

export const FormValueDisplay = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin: 25px 0 0 0;

  .secondary {
    font-size: 12px;
  }
`;

export const FormValueDisplayGroup = styled.div`
  width: 100%;
  overflow-y: auto;
  margin: 25px 0 0 0;
  max-height: 200px;
  padding-right: 10px;

  ${FormValueDisplay} {
    margin: 0 0 10px;

    &:last-child {
      margin: 0;
    }
  }
`;

export const CheckboxWrap = styled.div`
  display: flex;
  flex-direction: column;
  margin: 25px 0 0 7px;

  .MuiCheckbox-root {
    padding: 0 5px 0 0;
  }
`;

export const ModeDescription = styled.div`
  margin: -20px 0 20px 0;
  text-align: center;
  font-size: 14px;
`;

export const Error = styled.div`
  color: #7b0404;
  text-align: center;
  width: 100%;
  padding: 15px 0;
`;
